import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: { width: '100%', position: 'absolute', bottom: '0px', zIndex: 9999 } }
const _hoisted_2 = { style: { height: '14px' } }

import { defineComponent, ref, type Ref } from 'vue';
import stateLogin from '../../store/state-login';


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

defineComponent({ name: 'CwFooter' });

const appVersion: Ref<string> = ref(process.env.VUE_APP_VERSION);
console.log('appVersion: ', process.env);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "ma-0 pa-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "6" }),
        _createVNode(_component_v_col, {
          cols: "6",
          class: "text-end text-caption text-grey font-italic",
          style: _normalizeStyle({ fontSize: '0.6rem !important' })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(appVersion.value), 1)
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    })
  ]))
}
}

})